import { PageLink, PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import AppBackButton from "../appBackButton/AppBackButton";
import GlobalSearchResultsTable from "./components/GlobalSearchResultsTable";

const searchResultsBreadCrumbs: Array<PageLink> = [
  {
    title: "Search Results",
    path: "/SearchResults",
    isSeparator: false,
    isActive: true,
  },
];

const GlobalSearchResultsPage = () => {
  return (
    <CPLAnalytics pageName="Search Results">
      <PageTitle breadcrumbs={searchResultsBreadCrumbs}></PageTitle>
      <AppBackButton data-test-id="search-results__back-button" />
      <GlobalSearchResultsTable />
    </CPLAnalytics>
  );
};

export default GlobalSearchResultsPage;
